import classnames from 'classnames';
import React from 'react';

import { type BubbleButtonProps, bubbleButtonVariants } from './types';
import { ArrowRightUpIcon } from '../icons/react';

export default function ButtonWithBubble({
  children,
  url,
  variant = 'primary',
  className,
  ariaLabel,
  ...props
}: BubbleButtonProps) {
  const content = children;
  const accessibleLabel = ariaLabel || (typeof content === 'string' ? content : undefined);

  const resolvedVariant = bubbleButtonVariants.includes(variant) ? variant : 'primary';
  const resolvedSize = 'medium';

  const buttonContent = (
    <>
      {content ? <span className="bubble-button-label">{content}</span> : null}
      <span className="bubble-button-bubble" aria-hidden="true">
        <ArrowRightUpIcon />
      </span>
    </>
  );

  const containerClasses = classnames(
    'bubble-button',
    `button--${resolvedVariant}`,
    `button--${resolvedSize}`,
    className,
  );

  if (url) {
    return (
      <a
        href={url}
        className={containerClasses}
        aria-label={accessibleLabel}
        {...(props as React.AnchorHTMLAttributes<HTMLAnchorElement>)}
      >
        {buttonContent}
      </a>
    );
  }

  return (
    <button
      type="button"
      className={containerClasses}
      aria-label={accessibleLabel}
      {...(props as React.ButtonHTMLAttributes<HTMLButtonElement>)}
    >
      {buttonContent}
    </button>
  );
}
